import React from 'react';



type Props = {
	children: React.ReactNode,
};

const CenteredFormWrapper: React.FC<Props> = (props) => {
	const {
		children,
	} = props;

	return (
		<div className="centered-form-wrapper">
			{children}
		</div>
	);
};



export default CenteredFormWrapper;
